// utils
import { fetcher, poster, endpoints } from '../utils/axios';


/**
 * Get blog list
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameters are 'userType' which is 'user' or 'admin'
 * @return {Promise} Promise resolving to an object containing the list of blogs
 */
export async function getBlogList(payload){
    const URL = endpoints.blog.getBlogList;
    return await fetcher([URL,{params:payload}])
}